export default __webpack_public_path__ + "static/media/FOGQR.4d7dda18.png";